const ICONS = Object.freeze({
    mathematics: '/static/icons/mathIcon.png',
    english: '/static/icons/englishIcon.png',
    history: '/static/icons/historyIcon.png',
    lithuanian: '/static/icons/lithuanianIcon.png',
    chemistry: '/static/icons/chemistryIcon.png',
    physics: '/static/icons/physicsIcon.png',
    biology: '/static/icons/biologyIcon.png',
    it: '/static/icons/ITICon.png'
});

export const SUBJECT_NAMES = Object.freeze([
    'Matematika', 'Anglų kalba', 'Lietuvių kalba', 'Istorija', 'Chemija',
    'Fizika', 'Biologija', 'IT', 'Ispanų kalba', 'Matematika Rus.',
    'Lietuvių k. Rus.', 'Fizika Rus.', 'Matematika Angl.',
    'Lietuvių k. Angl.', 'Fizika Angl.', 'Rusų k.', 'IB Biologija',
    'IB Fizika', 'IB Matematika', 'Italų kalba', 'Matematika Lenk.',
    'Anglų k. Lenk.', 'Lietuvių k. Lenk.', 'Istorija Lenk.',
    'Chemija Lenk.', 'Fizika Lenk.', 'Biologija Lenk.', 'IT Lenk.',
    'Ispanų k. Lenk.', 'Rusų k. Lenk.', 'IB Biologija Lenk.',
    'IB Fizika Lenk.', 'IB Matematika Lenk.', 'Italų k. Lenk.'
]);

export const subjectOptions = Object.freeze(
    SUBJECT_NAMES.map(name => Object.freeze([name, name]))
);

export function getSubjectIcon(name) {
    if (name.includes('Matematika')) return ICONS.mathematics;
    if (name.includes('Lietuvių')) return ICONS.lithuanian;
    if (name.includes('Istorija')) return ICONS.history;
    if (name.includes('Chemija')) return ICONS.chemistry;
    if (name.includes('Fizika')) return ICONS.physics;
    if (name.includes('Biologija')) return ICONS.biology;
    if (name === 'IT' || name.startsWith('IT ')) return ICONS.it;
    return ICONS.english;
}

export function subjectCards() {
    return SUBJECT_NAMES.map(name => ({ name, icon: getSubjectIcon(name) }));
}

export function usesMathEditor(name) {
    return name.includes('Matematika') || name.includes('Fizika') || name.includes('Chemija');
}
